<template>
    <div class="w-md-50 mx-auto">
        <h1 class="text-center">Kérjük töltse ki az adatokat a játék elkezdéséhez!</h1>

        <form @submit.prevent="submit">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <label for="nickname">Becenév</label>
                    <input type="text" v-model="form.nickname" name="nickname" class="form-control" required>
                    <span v-if="'nickname' in errors" class="text-danger my-4">
                        {{ errors.nickname[0] }}
                    </span>
                </div>
                <div class="colsm-12 col-md-6">
                    <label for="email">E-mail cím</label>
                    <input type="email" v-model="form.email" name="email" class="form-control" required>
                    <span v-if="'email' in errors" class="text-danger my-4">
                        {{ errors.email[0] }}
                    </span>
                </div>
            </div>
            <div class="row text-right my-4">
                <div class="col-12 d-inline-flex flex-column justify-content-end" style="font-size: 90%;" v-if="$root.interactiveInterface.gdpr_page_id">
                    <label for="gdpr" style="cursor: pointer;">
                        <input type="checkbox" id="gdpr" v-model="form.gdpr" >
                        {{ $root.interactiveInterface.type_name }} indításásához el kell fogadni a <a :href="$root.interactiveInterface.gdpr_link" @click.prevent="showPrivacyModal" style="font-weight: bold;" target="_blank">játék feltételeit</a>
                    </label>
                    <span v-if="'gdpr' in errors" class="text-danger mb-4" style="font-size: 70%;">
                        {{ errors.gdpr[0] }}
                    </span>
                </div>
                <div class="col">
                    <button type="submit" class="btn btn-primary">Regisztráció</button>
                </div>
            </div>
        </form>

        <div class="modal fade" id="privacyModal" tabindex="-1" aria-labelledby="privacyModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title p-2" id="privacyModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="font-size: 1rem">
                        ...
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click.prevent="closePrivacyModal" class="btn btn-primary">Rendben</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            form: {
                nickname: '',
                email: '',
                uuid: this.$root.$data.user.fingerprint,
                gdpr: false,
            },
            errors: {},
            privacyModal: false,
        }
    },
    methods: {
        submit() {
            axios.post(
                `/interactive-interface/${window.InteractiveInterfaceCategorySlug}/${window.InteractiveInterfaceSlug}/register`,
                this.form
            ).then((response) => {
                this.$emit('registered', response.data.user);
            }).catch((error) => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        showPrivacyModal() {
            axios.get(`${this.$root.interactiveInterface.gdpr_link}`).then((response) => {
                $('#privacyModal').modal('show');
                $('#privacyModal .modal-title').text(response.data.title);
                $('#privacyModal .modal-body').html(response.data.body);
            });
        },
        closePrivacyModal() {
            $('#privacyModal').modal('hide');
        },
    },
}
</script>
